export enum DetectionFrameworkType {
    Framework = 'framework',
}
